import * as React from 'react';
import styled from 'styled-components';

const TrustBadgesContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 20px 0;
  flex-wrap: wrap;
`;

const Badge = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 15px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  font-size: 14px;
  font-weight: 500;

  i {
    font-size: 24px;
  }
  span {
    font-size: 14px;
    font-weight: 500;
    color: #333;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 8px 12px;
  }
`;

const SecurityBadge = styled(Badge)`
  color: #4caf50;
  i {
    color: #4caf50;
  }
`;

const GuaranteeBadge = styled(Badge)`
  color: #2196f3;
  i {
    color: #2196f3;
  }
`;

const SupportBadge = styled(Badge)`
  color: #ff9800;
  i {
    color: #ff9800;
  }
`;

export const TrustBadges: React.FC = () => {
  return (
    <TrustBadgesContainer>
      <SecurityBadge>
        <i className="material-icons">lock</i>
        <span>Pagamento Seguro</span>
      </SecurityBadge>
      <GuaranteeBadge>
        <i className="material-icons">verified_user</i>
        <span>Garantia 7 Dias</span>
      </GuaranteeBadge>
      <SupportBadge>
        <i className="material-icons">support_agent</i>
        <span>Suporte Premium</span>
      </SupportBadge>
    </TrustBadgesContainer>
  );
};
